<template>
  <div>
    <div>
      <st-header
        title="我的工单"
        :back-able="true"
      >
      </st-header>
    </div>
    <div class="afterSales">
      <div class="engineer">
        <p>您的专属售后工程师</p>
        <div class="engInfo">
          <img style="border-radius: 5px;" :src="info.engineer.avatar" alt="" />
          <div class="useInfo">
            <div class="name">{{ info.engineer.nickname }}</div>
            <div class="number" @click="call(info.engineer.mobile)">
              {{ info.engineer.mobile }}<el-icon><PhoneFilled /></el-icon>
            </div>
            <div>{{ info.engineer.email }}</div>
          </div>
        </div>
      </div>
      <div class="phone">
        <div>官方售后热线</div>
        <div @click="call(info.officialPhone)" class="phoneNumber">
          <p>{{info.officialPhone}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
export default {
  components: {
    StHeader,
  },
  props: {
    info: {
      type: Object,
      default: () => {
        // return {
        //   // officialPhone: 18161851839,
        //   officialPhone: 19128907063,
        //   engineer: {
        //     avatar: "https://7up.pics/images/2024/04/11/20240411-104215.jpeg",
        //     avatar: require("@/assets/images/engineer.jpeg"),
        //     nickname: "朱隽毅 June",
        //     email: "zhujunyi@ht-tek.com",
        //     // mobile: "18161851839",
        //     mobile: "19128907063",
        //   },
        // };
				
				return {
				  officialPhone: 19128907063,
				  engineer: {
				    avatar: "https://7up.pics/images/2024/04/11/20240411-104215.jpeg",
				    avatar: require("@/assets/images/engineer2.jpeg"),
				    nickname: "韦丽吉",
				    email: "liji.wei@ht-tek.com",
				    mobile: "19128907063",
				  },
				};
      }
    },
  },
  data() {
    return {
    };
  },
  created() {
    this.init();
  },
  mounted() {
    
  },
  watch: {
    value: {
      handler: function(newv, oldv) {
      },
      immediate: true,
      deep: true
    },
  },

  methods: {
    init() {},
    call(phone) {
      window.location.href = `tel:${phone}`;
    }
  },
};
</script>

<style scoped lang="scss">
div {
  box-sizing: border-box;
}
.afterSales {
  width: 100%;
  height: 94vh;
  background: rgba(243, 246, 250, 1);
  padding: 36px 24px;

  .engineer {
    padding: 15px;
    background: rgba(255, 255, 255, 1);
    height: 180px;
    border-radius: 5px;

    p {
      font-size: 18px;
      font-weight: bold;
    }
    .engInfo {
      display: flex;
      margin-top: 10px;
      img {
        height: 80px;
        margin-right: 10px;
      }
      .useInfo {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 16px;
        color: rgba(80, 80, 80, 1);
        .name {
          margin-top: 6px;
        }
        .number {
          display: flex;
          align-items: center;
          .el-icon {
            margin-left: 6px;
            font-size: 16px;
            color: rgba(153, 153, 153, 1);
          }
        }
      }
    }
  }
  .phone {
    div {
      font-size: 18px;
      font-weight: bold;
      padding: 15px 0px 10px;
    }
    .phoneNumber {
      width: 100%;
      height: 80px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      p {
        color: rgba(255, 141, 26, 1);
        font-size: 24px;
      }
    }
  }
}
</style>